// extracted by mini-css-extract-plugin
export default {"position":"style_position__o-Vmk","message":"style_message__djjds","trigger":"style_trigger__8EsdS","pulse":"style_pulse__F-Uyj"};